import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import StudentPDF from "./StudentPDF";
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo2.png";
import upperDesign from "../../assets/images/upperDesign.png";
import lowerDesign from "../../assets/images/lowerDesign.png";
import navigation from "../../assets/images/navigation.png";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiDownload } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";
import PDFViewerShimmer from "./PDFViewerShimmer";

const assets = {
  logo2: logo2,
  upper: upperDesign,
  lower: lowerDesign,
  logo: logo,
  navigation: navigation,
};

// Elegant Loading Component
const ElegantLoader = () => {
  return (
    <div style={{
      width: "100%",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#fafafa",
      fontFamily: "system-ui, -apple-system, sans-serif"
    }}>
      {/* Main Spinner */}
      <div style={{
        position: "relative",
        width: "60px",
        height: "60px",
        marginBottom: "24px"
      }}>
        {/* Outer Ring */}
        <div style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          border: "3px solid #e8e8e8",
          borderRadius: "50%"
        }}></div>
        
        {/* Animated Ring */}
        <div style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          border: "3px solid transparent",
          borderTopColor: "#007bff",
          borderRadius: "50%",
          animation: "elegantSpin 1.2s cubic-bezier(0.4, 0, 0.2, 1) infinite"
        }}></div>
        
        {/* Inner Dot */}
        <div style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "8px",
          height: "8px",
          backgroundColor: "#007bff",
          borderRadius: "50%",
          transform: "translate(-50%, -50%)",
          opacity: "0.8"
        }}></div>
      </div>

      {/* Loading Text */}
      <div style={{
        textAlign: "center"
      }}>
        <h3 style={{
          margin: "0 0 8px 0",
          fontSize: "18px",
          fontWeight: "600",
          color: "#2c3e50",
          letterSpacing: "0.3px"
        }}>
          Generating Report
        </h3>
        <p style={{
          margin: 0,
          fontSize: "14px",
          color: "#64748b",
          fontWeight: "400"
        }}>
          Please wait while we prepare your document...
        </p>
      </div>

      {/* Animated Dots */}
      <div style={{
        display: "flex",
        gap: "4px",
        marginTop: "20px"
      }}>
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            style={{
              width: "6px",
              height: "6px",
              backgroundColor: "#007bff",
              borderRadius: "50%",
              animation: `elegantPulse 1.4s ease-in-out ${i * 0.2}s infinite`
            }}
          ></div>
        ))}
      </div>

      <style>
        {`
          @keyframes elegantSpin {
            0% { 
              transform: rotate(0deg);
            }
            100% { 
              transform: rotate(360deg);
            }
          }
          
          @keyframes elegantPulse {
            0%, 80%, 100% {
              opacity: 0.3;
              transform: scale(0.8);
            }
            40% {
              opacity: 1;
              transform: scale(1);
            }
          }
        `}
      </style>
    </div>
  );
};

const ReportPagePDF = ({
  allReport, // Now contains single student object from API
  selectedStudentName,
  selectedStudentById,
}) => {
  const [loading, setLoading] = useState(true); // Start with loading true
  const navigate = useNavigate();

  // Manage loading state based on allReport data
  useEffect(() => {
    if (allReport && Object.keys(allReport).length > 0) {
      // Data loaded successfully
      setLoading(false);
    } else {
      // Data is still loading - keep showing spinner
      setLoading(true);
    }
  }, [allReport]);

  console.log("Student report data:", allReport);

  const getFileName = (name) => {
    if (!name) return "fytn-report-student.pdf";
    
    // Split the name into parts and clean them
    const nameParts = name.split(' ').filter(part => part.trim() !== '');
    
    if (nameParts.length >= 2) {
      // If we have first and last name
      const firstName = nameParts[0].replace(/[^a-z0-9]/gi, "").toLowerCase();
      const lastName = nameParts[nameParts.length - 1].replace(/[^a-z0-9]/gi, "").toLowerCase();
      return `fytn-report-${firstName}-${lastName}.pdf`;
    } else if (nameParts.length === 1) {
      // If we only have one name
      const firstName = nameParts[0].replace(/[^a-z0-9]/gi, "").toLowerCase();
      return `fytn-report-${firstName}.pdf`;
    } else {
      return "fytn-report-student.pdf";
    }
  };

  // Get the custom filename
  const customFileName = getFileName(selectedStudentName);

  // Show elegant loading spinner while data is being fetched
  if (loading || !allReport) {
    return <ElegantLoader />;
  }

  try {
    return (
      <>
        <div style={{ height: '100vh', width: '100%' }}>
          <PDFViewer width="100%" height="100%">
            <StudentPDF data={allReport} assets={assets} />
          </PDFViewer>
        </div>
      </>
    );
  } catch (error) {
    console.error("Error rendering PDF:", error);
    return (
      <div style={{ padding: '20px', color: 'red' }}>
        <h2>Error rendering PDF</h2>
        <p>{error.message}</p>
        <pre>{error.stack}</pre>
      </div>
    );
  }
};

export default ReportPagePDF;